import React from 'react'
import Breadcrumb from './Breadcrumb'

function About(title) {
    return (
        <>
       <div className="main">

{/* <!--header section start--> */}
<Breadcrumb title = {"About"} tag = "About"/>



{/* <!--about us section start--> */}
<section className="about-us-section ptb-30">
    <div className="container">
        <div className="row justify-content-between align-items-center">
            <div className="col-md-12 col-lg-7 order-2-mob">
                <div className="about-us-content-wrap">
                    <strong className="color-secondary">About Us</strong>
                    <h3>The New Way to success</h3>
                    <span className="animate-border mb-4"></span>
                    <p>Octave infosys is an expert at Web designing, Graphics design and small software development. This website brings you articles and updates from octave infosys. You will also find information & updates on Website Design, Web Marketing, Offers, Deals & Discounts and much more… </p>
                    <p>Octave Infosys - is a Web Design and Development Company in India. Since its founding in 2017, the designers at octave infosys have passionately created countless engaging and profitable websites for large and small businesses around the world.Based in Mumbai, India, octave infosys provides a complete range of web development services including website hosting and maintenance, domain registration, on-page search engine optimization, and website integration with social media platforms such as Facebook, Twitter, LinkedIn, Google Maps, and Google Local Directory.</p>
                    <p>Talent, experience, and dedication are the defining characteristics of the octave infosys team. We value open communication and collaboration with our clients; always focused on delivering the latest technologies and business practices that will translate to profitability. While our company has undoubtedly grown since 2017, our steadfast dedication to treating each customer as if they were our first remains unchanged.</p>
                </div>
            </div>
            <div className="col-md-12 col-lg-5">
                <div className="card border-0 text-white">
                    <img src="assets1/img/why-choose-us.png" alt="video" className="img-fluid"/>
                        <div className="card-img-overlay text-center">
                            <a href="https://www.youtube.com/watch?v=HgDrRkFnChM" className="popup-youtube video-play-icon color-bip shadow"><span className="ti-control-play"></span> </a>
                           
                        </div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* <!--promo section start--> */}
    <section className="promo-section ptb-70">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <div className="my-shadow promo-single-wrap p-5 text-center border rounded" style={{boxShadow: "10px 15px 30px rgb(1 39 80 / 50%)"}}>
                        <div className="promo-icon mb-4">
                            <img src="assets1/img/search-engine.svg" alt="promo" width="65"/>
                            <span className="number-bg">01</span>
                        </div>
                        <div className="promo-info">
                            <strong className="color-secondary">Discuss with Users</strong>
                            <h4>Site Optimisation</h4>
                            <p>Website optimization is the process of using tools, advanced strategies, and experiments to improve the performance of website's ability to drive business goals.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="promo-single-wrap p-5 text-center border rounded" style={{boxShadow: "10px 15px 30px rgb(1 39 80 / 50%)"}}>
                        <div className="promo-icon mb-4">
                            <img src="assets1/img/increase.svg" alt="promo" width="65"/>
                            <span className="number-bg">02</span>
                        </div>
                        <div className="promo-info">
                            <strong className="color-secondary">Discuss with Users</strong>
                            <h4>Increased Traffic</h4>
                            <p>SEO (Search Engine Optimization)is nothing but the process of getting traffic from free, organic, editorial or natural search results on search engines</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4">
                    <div className="promo-single-wrap p-5 text-center border rounded" style={{boxShadow: "10px 15px 30px rgb(1 39 80 / 50%)"}}>
                        <div className="promo-icon mb-4">
                            <img src="assets1/img/bullhorn.svg" alt="promo" width="65"/>
                            <span className="number-bg">03</span>
                        </div>
                        <div className="promo-info">
                            <strong className="color-secondary">Discuss with Users</strong>
                            <h4>Digital Marketing</h4>
                            <p>Digital marketing is the process of creating content that you have tailored to the context of each individual social media platform in order to drive user engagement.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!--promo section end--> */}

{/* <!--work process section start--> */}
<section className="work-process-section ptb-100 gray-light-bg">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-10 col-lg-9">
                <div className="section-heading text-center">
                    <strong className="color-secondary">Work Process</strong>
                    <h2>We follow Few Steps</h2>
                    <span className="animate-border mr-auto ml-auto mb-4"></span>
                    <p className="lead">Our web design and development team come up with a detailed cost-benefit analysis for the project with an output of realistic plan.</p>
                </div>
            </div>
        </div>
        {/* <!-- ============ step 1 =========== --> */}
        <div className="row mt-5">
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-left">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">01</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Planning Stage</h5>
                            <i className="fas fa-file-signature fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-l"></div>
                </div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-5 col-md-5 col-lg-5 process-none">
                <div className="process-point-right"></div>
            </div>
        </div>
        {/* <!-- ============ step 2 =========== --> */}
        <div className="row">
            <div className="col-md-5 col-lg-5 process-none">
                <div className="process-point-left"></div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-right">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">02</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Gather Content</h5>
                            <i className="fas fa-file-invoice fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-r"></div>
                </div>
            </div>

        </div>
        {/* <!-- ============ step 3 =========== --> */}
        <div className="row">
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-left">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">03</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Plan Structure</h5>
                            <i className="fas fa-sitemap fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-l"></div>
                </div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-5 col-lg-5 process-none">
                <div className="process-point-right"></div>
            </div>
        </div>
        {/* <!-- ============ step 4 =========== --> */}
        <div className="row">
            <div className="col-md-5 col-lg-5 process-none">
                <div className="process-point-left"></div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-right">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">04</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Design</h5>
                            <i className="fas fa-palette fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-r"></div>
                </div>
            </div>
        </div>
        {/* <!-- ============ step 5 =========== --> */}
        <div className="row">
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-left">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">05</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Testing</h5>
                            <i className="fab fa-searchengin fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-l"></div>
                </div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-5 col-lg-5 process-none">
                <div className="process-point-right"></div>
            </div>
        </div>
        {/* <!-- ============ step 6 =========== --> */}
        <div className="row">
            <div className="col-md-5 col-lg-5 process-none">
                <div className="process-point-left process-last"></div>
            </div>
            <div className="col-md-2 process-none"></div>
            <div className="col-md-12 col-lg-5 process-width">
                <div className="process-box process-right">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="process-step-number">
                                <strong>Step</strong>
                                <h2 className="m-0">06</h2>
                            </div>
                        </div>
                        <div className="col-md-7" style={{textAlign: 'center'}}>
                            <h5>Live</h5>
                            <i className="fas fa-wifi fa-5x" style={{color: '#2557a5' }}></i>
                        </div>
                    </div>
                    <div className="process-line-r"></div>
                </div>
            </div>
        </div>
        {/* <!-- ============ --> */}
    </div>
</section>
{/* <!--work process section end--> */}
</div>
        </>
    )
}

export default About
